export * as spinnerStyleConfigs from './style-configs';

export { Spinner, type SpinnerProps } from '@chakra-ui/react';
